import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

export const useCustomizations = () => {
  const themeContext = useContext(ThemeContext);
  return themeContext?.customizations || {};
};

export function useFeatureFlag(flagName) {
  const customizations = useCustomizations();
  return customizations[flagName];
}
